import request from '@/config/axios'

export interface BusinessUser {
  id: number
  userId: number
  nickname: string
  avatar: string
  memberMobile: string
  memberEmail: string
  contactMobile: string
  industry?: string
  position?: string
  company?: string
  tags?: string
  intro?: string
  backgroundImg?: string
  mobile?: string
  email?: string
  website?: string
  address?: string
  status: number
  createTime: string
}

export const getUserPage = (params: PageParam & Record<string, any>) =>
  request.get({ url: '/bosscircle/user/page', params })

export const getUser = (id: number) => request.get({ url: '/bosscircle/user/get', params: { id } })

export const updateUser = (data: Partial<BusinessUser>) =>
  request.put({ url: '/bosscircle/user/update', data })

export const updateUserStatus = (userId: number, status: number) =>
  request.put({ url: '/bosscircle/user/update-status', data: { userId, status } })

export const deleteUser = (id: number) =>
  request.delete({ url: '/bosscircle/user/delete', params: { id } })
